import styled from 'styled-components';

const ImageStyle = styled.div`
	--proportion: 50%;

	position: relative;
	width: 100%;
	padding-top: var(--proportion);
	transition: background-color var(--trTime) ease-out;

	img {
		object-fit: cover;
		object-position: center;
		transition: opacity 0.6s ease-out;
	}

	&.contain {
		img {
			object-fit: contain;
		}
	}
`;

export default ImageStyle;
